import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Input } from "rbx";

// import { getISODate } from "../../utils";

function DateTimeInput({
  name,
  label,
  value: initialValue,
  onChange,
  ...props
}) {
  const [value, setValue] = useState(initialValue);

  const handleChange = e => {
    setValue(e.target.value);
  };
  const handleBlur = () => {
    onChange({ target: { name, value } });
  };
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <Input
      autocomplete="new"
      type="datetime-local"
      {...props}
      handleBlur={handleBlur}
      id={label}
      name={name}
      value={value}
      onChange={handleChange}
    />
  );
}

DateTimeInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)])
    .isRequired,
  onChange: PropTypes.func
};

export default DateTimeInput;
